import GoogleIcon from 'assets/images/google_logo.svg'

import s from './GoogleRankPill.module.css'

type Props = {
  googleRank: number
}

export const GoogleRankPill = ({ googleRank }: Props) => {
  return (
    <div className={s.wrapper}>
      <img src={GoogleIcon} width={13} alt="google-logo" />#
      {Math.round(googleRank)}
    </div>
  )
}
